import React from "react";
import dynamic from "next/dynamic";
import { useSearchParams } from "next/navigation";

import { useEventTracker } from "@/hooks/useEventTracker";
import useFilters from "@/hooks/useFilters";

const Dropdown = dynamic(() => import("@/components/botanic/Dropdown"), {
  ssr: true,
});
import Placeholder, { Rect } from "@/components/Skeleton";

/* eslint-disable sort-keys-fix/sort-keys-fix -- exception: order matters */
const sortOptions: { [key: string]: string } = {
  Recommended: "recommended:asc",
  "A-Z": "strain_name:asc",
  "Z-A": "strain_name:desc",
  "Highest Rated": "rating:desc",
  "Most Reviews": "review_count:desc",
  Newest: "created:desc",
};
/* eslint-enable sort-keys-fix/sort-keys-fix -- exception: order matters */

const StrainListCountSort: React.FC<{
  totalCount?: number;
  loading?: boolean;
}> = ({ totalCount, loading }) => {
  const { swapFilter } = useFilters({ shallowRouting: false });
  const sortParam =
    useSearchParams()?.get("sort")?.toString() || sortOptions.Recommended;
  const { publishEvent } = useEventTracker();

  return (
    <div className="flex justify-between items-center mb-sm">
      <div className="text-xs font-bold">
        {!loading ? (
          `${totalCount} strains`
        ) : (
          <Placeholder height="20" width="70">
            <Rect height="100%" width="100%" />
          </Placeholder>
        )}
      </div>

      <Dropdown
        data-testid="strainlist-sort"
        label="Sort by"
        variant="small"
        options={Object.keys(sortOptions)}
        onItemRender={(option) => ({
          children: option,
          onClick: () => {
            swapFilter([sortOptions[sortParam]], { sort: sortOptions[option] });
            publishEvent({
              action: "Click",
              category: "Strains Sort",
              label: option,
            });
          },
        })}
      />
    </div>
  );
};

export default StrainListCountSort;
